import api from 'lib/trpcClient';
import { AllocationRule } from 'further-types/lp/allocations';

export type GenerateAllocationsParams = {
  allocationRule: AllocationRule;
  vehicleId: string;
  amountTcy: number;
  excludedCommitmentIds: Array<string>;
  commitmentIdsToConsider?: Array<string>;
  currentActionIds?: Array<string>;
  sourceAllocationActionId?: string | null;
  shouldIncludeCommitmentsBeingEqualised?: boolean;
};

const useAllocationsApi = () => {
  const {
    data: initialAllocationsData,
    mutate,
    isPending,
  } = api.allocations.generateAllocations.useMutation();

  const generateAllocations = ({
    allocationRule,
    vehicleId,
    amountTcy,
    excludedCommitmentIds,
    commitmentIdsToConsider,
    currentActionIds,
    sourceAllocationActionId,
    shouldIncludeCommitmentsBeingEqualised,
  }: GenerateAllocationsParams) => {
    return mutate({
      allocationRule,
      vehicleId,
      amountTcy,
      excludedCommitmentIds,
      commitmentIdsToConsider,
      currentActionIds,
      sourceAllocationActionId: sourceAllocationActionId ?? undefined,
      shouldIncludeCommitmentsBeingEqualised,
    });
  };

  return {
    initialAllocationsData,
    generateAllocations,
    isPending,
  };
};

export default useAllocationsApi;
